import React, { Component } from 'react'
import { Col, Row, Form, Button, Spinner } from "react-bootstrap-v5";
import { toast } from "react-toastify";
import { revenuecostService } from '../../../../Services/revenuecostService';
import Currency from '../../../../Function/currency.json'
import helperFunction from '../../../../Function/helperFunction';
import { FaTrashAlt } from 'react-icons/fa';

export default class EditInvoice extends Component {
    state = {
        buttonSubmit: true,
        invItems: this.props.invoiceItem
    }

    handleInputChange(e, index) {
        const { name, value } = e.target
        const { invItems } = this.state
        let updateItem = invItems.item

        if (index !== '') {
            // To set value in to state
            updateItem[index][name] = value

            if (name === 'currency') {
                updateItem[index]['currency'] = { cc: value }
            }

            if (name === 'rate_per_qty') {
                let rpq = value
                let exRate = updateItem[index]['ex_rate']
                let lcAmt = (rpq * exRate).toFixed(3)

                let vat = updateItem[index]['vat']
                let gcAmtPercent = 0
                if (vat === 12) {
                    gcAmtPercent = (lcAmt * 5) / 100
                }
                let gcAmt = Number(gcAmtPercent) + Number(lcAmt)

                updateItem[index]['lc_amount'] = lcAmt
                updateItem[index]['glc_amount'] = gcAmt
                updateItem[index]['taxable_amount'] = gcAmtPercent.toFixed(2)

            }

            // Calculate and set for LC amount and Gross LC amount
            if (name === 'ex_rate') {
                let rpq = updateItem[index]['rate_per_qty']
                let lcAmt = (rpq * value).toFixed(3)
                let vat = updateItem[index]['vat']
                updateItem[index]['lc_amount'] = lcAmt
                let gcAmtPercent = 0
                if (vat === 12) {
                    gcAmtPercent = (lcAmt * 5) / 100
                }
                let gcAmt = Number(gcAmtPercent) + Number(lcAmt)
                updateItem[index]['taxable_amount'] = gcAmtPercent.toFixed(2)
                updateItem[index]['glc_amount'] = gcAmt
            }

            if (name === 'vat' && value !== 0) {
                console.log("==vat====")
                updateItem[index]['vat'] = Number(updateItem[index]['vat']);
                let lcAmt = updateItem[index]['lc_amount']
                // let gcAmtPercent = (lcAmt * value) / 100
                // let gcAmt = Number(gcAmtPercent) + Number(lcAmt)
                // updateItem[index]['glc_amount'] = gcAmt
                // updateItem[index]['taxable_amount'] = gcAmtPercent

                let vatPer = value === "12" ? 5 : 0
                let gcAmtPercent = 0
                if (vatPer === 0) {
                    gcAmtPercent = 0
                } else {
                    gcAmtPercent = ((lcAmt * vatPer) / 100).toFixed(2);
                }

                let gcAmt = Number(gcAmtPercent) + Number(lcAmt);
                updateItem[index]['glc_amount'] = gcAmt
                updateItem[index]['taxable_amount'] = gcAmtPercent

            }
        }

        this.setState({ ...invItems, item: updateItem })
    }

    handleSubmit = () => {
        this.setState({ buttonSubmit: false })
        const { invItems } = this.state
        const { invoiceItem, jobId } = this.props
        let totalAmt = invItems.item.reduce((total, item) => Number(item.glc_amount) + total, 0)

        
        var invoiceUpdate = {}
        invoiceUpdate.id = invItems._id
        invoiceUpdate.item = invItems.item
        invoiceUpdate.gross_amount = totalAmt ? helperFunction.handleDecimalPoints(totalAmt,3) : totalAmt
        invoiceUpdate.draft = true
        invoiceUpdate.created_date = new Date(invItems.created_date)
        
        if(invItems.quickBookdata && invItems.draft===false){
            let postData = {}
            postData.job_id = jobId
            postData.item = invItems.item
            postData.qid = invoiceItem.quickBookdata.invoice_id
            postData.created_date = new Date(invItems.created_date)
            revenuecostService.invoiceUpdateQB(postData).then(result => {
                if (result.status === true) {
                    invoiceUpdate.quickBookdata = {
                        invoice_id: result.data.json.Invoice.Id,
                        json: result.data
                    }
                    invoiceUpdate.draft = false
                    this.updateInvoice(invoiceUpdate)
                } else {
                    if (result.data) {
                        toast.error("Quickbook error :" + result.data);
                    }
                    this.setState({ buttonSubmit: true })
                }
            })
        }else{
            this.updateInvoice(invoiceUpdate)
        }

    }

    updateInvoice = (invoiceUpdate) => {
        const { invoiceModal } = this.props
        revenuecostService.updateInvoice(invoiceUpdate).then(result1 => {
            if (result1.status === true) {
                toast.success(result1.message)
                this.props.profitNLoss()
                invoiceModal(false)
            } else {
                if (result1.data) {
                    toast.error("Quickbook error :" + result1.data);
                }
            }
            this.setState({ buttonSubmit: true })
        })
    }

    handleAddItem = () => {
        const stateCopy = { ...this.state.invItems }
        stateCopy.item = [ ...stateCopy.item , 
            {
                item_name: "",
                rate_per_qty: "",
                other_amount: "",
                currency: { cc: "AED" },
                description: "",
                ex_rate: 1,
                lc_amount: "",
                vat: 2,
                taxable_amount: "",
                glc_amount: "",
                created_date : ""
            },
        ]
        this.setState({ invItems : stateCopy })
    }

    handleRemoveItem = (i) => {
        const stateCopy = { ...this.state.invItems }
        stateCopy.item.splice(i, 1)
        this.setState({ invItems : stateCopy })       
    }

    handleInvoiceChange = (e) => {
        const stateCopy = { ...this.state.invItems }
        stateCopy.created_date = e.target.value
        this.setState({ invItems : stateCopy })   
    }

    render() {
        const { invItems, buttonSubmit } = this.state
        // const { invoiceItem, quoteToken, jobId, carrierData, receiverData } = this.props
        // console.log("invItems---", invItems)
        // console.log(invItems.created_date)
        // console.log(new Date(invItems.created_date))
        // console.log(new Date(invItems.created_date).toISOString())

        return (
            <Form>
                {/* <Col md={3}>
                    <Form.Group className="mb-3">
                        <Form.Label>Invoice Date</Form.Label>
                        <Form.Control
                            name="created_date"
                            type="date"
                            value={invItems.created_date.slice(0, 10)}
                            onChange={(e) => this.handleInvoiceChange(e)}
                        />
                    </Form.Group>
                </Col> */}
                {
                    invItems
                    && invItems.item.length > 0
                    && invItems.item.map((item, index) => {
                        return <Row className="square border-bottom mt-1" bg="primary" key={index}>
                            <Col md={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Select Job Item</Form.Label>
                                    <Form.Select name="item_name" value={item.item_name} onChange={(e) => this.handleInputChange(e, index)} >
                                        <option value="">Select</option>
                                        <option value="AIR FREIGHT CHARGES">AIR FREIGHT CHARGES</option>
                                        <option value="SEA FREIGHT CHARGES">SEA FREIGHT CHARGES</option>
                                        <option value="LAND FREIGHT CHARGES">LAND FREIGHT CHARGES</option>
                                        <option value="COURIER CHARGES">COURIER CHARGES</option>
                                        <option value="LOCAL TRANSPORTATION">LOCAL TRANSPORTATION</option>
                                        <option value="PACKING CHARGES">PACKING CHARGES</option>
                                        <option value="INSURANCE PREMIUM">INSURANCE PREMIUM</option>
                                        <option value="STORAGES CHARGES">STORAGES CHARGES</option>
                                        <option value="OTHER SERVICES">OTHER SERVICES</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control
                                        name="description"
                                        value={item.description}
                                        onChange={(e) => this.handleInputChange(e, index)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={1}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Rate</Form.Label>
                                    <Form.Control
                                        name="rate_per_qty"
                                        value={item.rate_per_qty}
                                        onChange={(e) => this.handleInputChange(e, index)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Currency</Form.Label>
                                    <Form.Select name="currency"
                                        value={item?.currency.cc || "AED"}
                                        onChange={(e) => this.handleInputChange(e, index)} >
                                        <option>Currency</option>

                                        {Currency.map(item1 => {
                                            return <option value={item1.cc}>{item1.cc} ({item1.symbol})</option>
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={1}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Ex Rate</Form.Label>
                                    <Form.Control
                                        name="ex_rate"
                                        value={item.ex_rate}
                                        onChange={(e) => this.handleInputChange(e, index)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={1}>
                                <Form.Group className="mb-3">
                                    <Form.Label>LC Amount</Form.Label>
                                    <Form.Control
                                        name="lc_amount"
                                        value={item.lc_amount}
                                        onChange={(e) => this.handleInputChange(e, index)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Vat</Form.Label>
                                    <Form.Select
                                        name="vat"
                                        defaultValue={2}
                                        value={item.vat}
                                        onChange={(e) => this.handleInputChange(e, index)} >
                                        {/* <option>0</option>
                                        <option value={5}>5</option>
                                        <option value={10}>10</option> */}
                                        <option value={2}>Zero-Rated</option>
                                        <option value={4}>Exempt From VAT</option>
                                        <option value={12}>SR Standard Rated (DXB) SS-DXB</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            {invItems.item.length > 1 && 
                                <Col md={1}>
                                    <Button
                                        className="mt-4"
                                        variant="danger"
                                        size="sm"
                                        onClick={() => this.handleRemoveItem(index)}
                                        >
                                        <FaTrashAlt />
                                    </Button>
                                </Col>
                            }
                            <Col md={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>VAT Amount</Form.Label>
                                    <Form.Control
                                        name="vat_amount"
                                        value={item.taxable_amount}
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Gross LC Amount</Form.Label>
                                    <Form.Control
                                        name="glc_amount"
                                        value={item.glc_amount}
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    })
                }

                <Row>
                    <Button
                        style={{ width : "12%"}}
                        className="ms-2 my-3"
                        variant="success"
                        size="sm"
                        onClick={() => this.handleAddItem()}
                        >
                        Add Item
                    </Button>
                 
                </Row>
                <Row className='px-2'>
                    {buttonSubmit && <Button  onClick={() => this.handleSubmit()}>Save</Button>}
                    {!buttonSubmit
                        && <Button variant="primary" disabled >
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            Loading...
                        </Button>
                    }
                </Row>
            </Form>
        )
    }
}
